var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.418 35.2405C33.0662 35.2405 37.5239 33.3841 40.8107 30.0797C44.0975 26.7752 45.9439 22.2934 45.9439 17.6203C45.9439 12.9471 44.0975 8.4653 40.8107 5.16086C37.524 1.85642 33.0662 9.09903e-07 28.418 0L28.418 9.72152C30.5109 9.72153 32.5181 10.5223 33.998 12.0102C35.4779 13.4981 36.2744 15.5161 36.2744 17.6203C36.2744 19.7244 35.4779 21.7424 33.998 23.2303C32.5181 24.7182 30.5109 25.519 28.418 25.519L28.418 35.2405Z",
    fill: "url(#paint0_linear_222_7687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7051 4.86076C12.7051 2.17624 14.8697 0 17.5398 0L28.418 0L28.418 9.72152H17.5398C14.8697 9.72152 12.7051 7.54529 12.7051 4.86076Z",
    fill: "url(#paint1_linear_222_7687)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7051 30.3798C12.7051 27.6952 14.8697 25.519 17.5398 25.519H28.418L28.418 35.2405H17.5398C14.8697 35.2405 12.7051 33.0643 12.7051 30.3798Z",
    fill: "url(#paint2_linear_222_7687)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5342 12.7595C12.886 12.7595 8.4282 14.6159 5.14145 17.9203C1.8547 21.2248 0.00822261 25.7065 0.0082222 30.3797C0.0082218 35.0529 1.8547 39.5347 5.14145 42.8391C8.4282 46.1436 12.886 48 17.5342 48L17.5342 38.2785C15.4412 38.2785 13.4341 37.4777 11.9541 35.9898C10.4742 34.5019 9.67771 32.4839 9.67771 30.3797C9.67771 28.2756 10.4742 26.2576 11.9541 24.7697C13.4341 23.2818 15.4412 22.481 17.5342 22.481L17.5342 12.7595Z",
    fill: "url(#paint3_linear_222_7687)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2471 43.1392C33.2471 45.8238 31.0825 48 28.4123 48L17.5342 48L17.5342 38.2785L28.4123 38.2785C31.0825 38.2785 33.2471 40.4547 33.2471 43.1392Z",
    fill: "url(#paint4_linear_222_7687)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2471 17.6202C33.2471 20.3048 31.0825 22.481 28.4123 22.481L17.5342 22.481L17.5342 12.7595L28.4123 12.7595C31.0825 12.7595 33.2471 14.9357 33.2471 17.6202Z",
    fill: "url(#paint5_linear_222_7687)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8107 5.16086C44.0974 8.4653 47.4548 14.2785 45.3396 22.1772C45.3396 12.6945 36.2744 9.72153 28.418 9.72153H17.5398C14.8697 9.72153 12.7051 7.54529 12.7051 4.86076C12.7051 2.17624 14.8697 0 17.5398 0H28.418C33.0662 0 37.5239 1.85642 40.8107 5.16086Z",
    fill: "url(#paint6_linear_222_7687)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15099 42.8354C1.22276 38.6739 -1.50947 32.5063 0.91425 24.9114C0.914252 34.6329 10.58 38.2785 18.138 38.2785L28.4118 38.2785C30.9806 38.2785 33.2529 40.4179 33.2529 43.1392C33.2529 45.8605 31.1706 48 28.6019 48L17.2378 48C12.7663 48 8.31288 46.1851 5.15099 42.8354Z",
    fill: "url(#paint7_linear_222_7687)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_7687",
    x1: 41.8114,
    y1: 12.4851,
    x2: 27.0785,
    y2: 39.1964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2278F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_7687",
    x1: 41.8114,
    y1: 12.4851,
    x2: 27.0785,
    y2: 39.1964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2278F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_7687",
    x1: 41.8114,
    y1: 12.4851,
    x2: 27.0785,
    y2: 39.1964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2278F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_7687",
    x1: 32.6347,
    y1: 10.6329,
    x2: 16.5966,
    y2: 41.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_222_7687",
    x1: 32.6347,
    y1: 10.6329,
    x2: 16.5966,
    y2: 41.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_222_7687",
    x1: 32.6347,
    y1: 10.6329,
    x2: 16.5966,
    y2: 41.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_222_7687",
    x1: 17.0888,
    y1: 3.20718,
    x2: 42.7458,
    y2: 10.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_222_7687",
    x1: 4.67087,
    y1: 31.6136,
    x2: 33.914,
    y2: 46.8673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon);
export default __webpack_public_path__ + "static/media/Logo icon.bc4a669ed024d404ad11a4411ea18cfd.svg";
export { ForwardRef as ReactComponent };